import React from 'react';
import { Message } from "primereact/message";

import config from '../config.json';
import axios from 'axios';

export const MANAGE_PEOPLE = "MANAGE_PEOPLE";
export const MANAGE_REPORTS = "MANAGE_REPORTS";
export const MANAGE_CLIENTS = "MANAGE_CLIENTS";
export const MANAGE_PROFILES = "MANAGE_PROFILES";
export const MANAGE_TAGS = "MANAGE_TAGS";
export const MANAGE_CONFIGURATION = "MANAGE_CONFIGURATION";
export const MANAGE_CUSTOMERS = "MANAGE_CUSTOMERS";
export const MANAGE_SUBSCRIPTIONPLANS = "MANAGE_SUBSCRIPTIONPLANS";

export const Permissions = [
    {label: 'Manage People', value: 'MANAGE_PEOPLE'},
    {label: 'Manage Reports', value: 'MANAGE_REPORTS'},
    {label: 'Manage Clients', value: 'MANAGE_CLIENTS'},
    {label: 'Manage Profiles', value: 'MANAGE_PROFILES'},
    {label: 'Manage Tags', value: 'MANAGE_TAGS'},
    {label: 'Manage Configurations', value: 'MANAGE_CONFIGURATION'},
    {label: 'Manage Customers', value: 'MANAGE_CUSTOMERS'},
    {label: 'Manage Subscription Plans', value: 'MANAGE_SUBSCRIPTIONPLANS'}
];

/*eslint no-eval: 0*/
export class AuthorizationService {

    constructor(){
        this.loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
        this.permissions = ((this.loggedInUser || {}).permissions || []);
    }

    getCurrentUser = () => {
        return this.loggedInUser;
    }

    getCurrentUserId = () => {
        return this.loggedInUser.id;
    }

    hasPermission = (permission) => {
        return this.loggedInUser.superadmin || this.permissions.indexOf(permission) >= 0;
    }

    getModules = () => {
        return this.loggedInUser.modules || [];
    }

    canEditEntity = (entityId) => {
        return this.hasPermission(`UPDATE_${entityId.toUpperCase()}`);
    }

    canDeleteEntity = (entityId) => {
        return this.hasPermission(`DELETE_${entityId.toUpperCase()}`);
    }

    canViewEntity = (entityId) => {
        return this.hasPermission(`VIEW_${entityId.toUpperCase()}`);
    }

    canCreateEntity = (entityId) => {
        return this.hasPermission(`CREATE_${entityId.toUpperCase()}`);
    }

    can = (operation, entityId) => {
        return this.hasPermission(`${operation.toUpperCase()}_${entityId.toUpperCase()}`);
    }

    permissionDeniedComponent = () => {
        return <Message severity="error" text="Permission denied" style={{width: '100%'}}/>
    }

    handleEntityFormScreen = (params, componentToShow) => {
        if(params.id === "new"){
            return this.canCreateEntity(params.entity) ? componentToShow : this.permissionDeniedComponent()
        }
        else {
            return this.canViewEntity(params.entity) || this.canEditEntity(params.entity) || this.canDeleteEntity(params.entity) ? componentToShow : this.permissionDeniedComponent()
        }
    }

    handleEntityListScreen = (params, componentToShow) => {
        return this.canCreateEntity(params.entity) || this.canViewEntity(params.entity) || this.canEditEntity(params.entity) || this.canDeleteEntity(params.entity) ? componentToShow : this.permissionDeniedComponent()    
    }

    handleScreenByPermission = (permission, componentToShow) => {
        return this.hasPermission(permission) ? componentToShow : this.permissionDeniedComponent()    
    }

    canViewEntityMenuItem = (entityId) => {
        return this.canCreateEntity(entityId) || this.canViewEntity(entityId) || this.canEditEntity(entityId) || this.canDeleteEntity(entityId);
    }

    canViewEntitysMenuItem = (entityIds) => {

        for(let i = 0; i < entityIds.length; i++){
            if(this.canViewEntityMenuItem(entityIds[i])){
                return true;
            }
        }
        return false;
    }

    getClientByShortcode = async (shortcode) => {
        return (await axios.get(`${config.BASE_URL}shortcodes/${shortcode}`)).data;
    }

    getClientByURL = async (host, path) => {
        try {
            return (await axios.post(`${config.BASE_URL}urlresolver`, {host, path})).data;    
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    login = async (username, password, client) => {
        return (await (axios.post(`${config.BASE_URL}login`, { username, password, client }))).data;
    }

    loginWithADB2C = async (accountId, token, client) => {
        return (await (axios.post(`${config.BASE_URL}login-adb2c`, { accountId, token, client }))).data;
    }   

    signup = async (name, email, extraFields, termsOfUseAcceptedOn, client) => {
        return (await (axios.post(`${config.BASE_URL}signup`, { name, email, extraFields, termsOfUseAcceptedOn, client }))).data;
    }

    requestPasswordReset = async (username, client) => {
        return (await (axios.post(`${config.BASE_URL}request-password-reset`, { username, client }))).data;
    }

    setPassword = async (token, password) => {
        return (await (axios.post(`${config.BASE_URL}setpassword`, { token, password }))).data;
    }

    updatePassword = async (currentpassword, newpassword) =>    {
        return (await (axios.post(`${config.BASE_URL}update-password`, { currentpassword, newpassword }))).data;
    }

    rootLogin = async (username, password) => {
        return (await (axios.post(`${config.BASE_URL}login`, { username, password }))).data;
    }
    
    updateFavorites = async (newLoggedInUser) => {
        await (axios.post(`${config.BASE_URL}favorites`, newLoggedInUser.favorites || []))
        localStorage.setItem("loggedInUser", JSON.stringify(newLoggedInUser));
    }

    updateBookmarks = async (newLoggedInUser) => {
        await (axios.post(`${config.BASE_URL}bookmarks`, newLoggedInUser.bookmarks || []))
        localStorage.setItem("loggedInUser", JSON.stringify(newLoggedInUser));
    }
}